import React from "react";
import { Provider } from "jotai";

import ecomWebAppJotaiStore from "./ecom-web-app-jotai-store";

const EcomWebAppJotaiProvider = ({ children }) => {
  return <Provider store={ecomWebAppJotaiStore}>{children}</Provider>;
};

export default EcomWebAppJotaiProvider;
